/* attribute */
import excludeAttrList, { ExcludeAttrList } from './attribute/exclude_attr_list';
import includeAttrList, { IncludeAttrList } from './attribute/include_attr_list';
import setAttr, { SetAttr } from './attribute/set_attr';
import setAttrs, { SetAttrs } from './attribute/set_attrs';

/* constants */
import { noEl } from './core/constants';

/* database */
import write, { Write } from './database/write';
import read, { Read } from './database/read';

/* element */
import existsIn, { ExistsIn } from './element/exists_in';
import parentsOf, { ParentsOf } from './element/parents_of';
import queryAll, { QueryAll } from './element/query_all';
import queryOne, { QueryOne } from './element/query_one';
import removeAll, { RemoveAll } from './element/remove_all';

/* is */
import customElement, { IsCustomElement } from './is/is_custom_element';
import element, { IsElement } from './is/is_element';
import node, { IsNode } from './is/is_node';
import someTag, { IsSomeTag } from './is/is_some_tag';
import tag, { IsTag } from './is/is_tag';

/* model */
import create, { Create } from './model/create';
import destroy, { Destroy } from './model/destroy';

/* query */
import focusable, { TQueryFocusable } from './query/query_focusable';
import main, { TQueryMain } from './query/query_main';

/* strategy */
import region, { TRegionStrategy } from './strategy/region';

export interface DOM {
  /* attribute */
  readonly excludeAttrList: ExcludeAttrList;
  readonly includeAttrList: IncludeAttrList;
  readonly setAttrs: SetAttrs;
  readonly setAttr: SetAttr;

  /* constants */
  constants: {
    noEl: HTMLElement;
  };

  /* database */
  readonly write: Write;
  readonly read: Read;

  /* element */
  readonly existsIn: ExistsIn;
  readonly parentsOf: ParentsOf;
  readonly queryAll: QueryAll;
  readonly queryOne: QueryOne;
  readonly removeAll: RemoveAll;

  /* is */
  is: {
    readonly customElement: IsCustomElement;
    readonly element: IsElement;
    readonly node: IsNode;
    readonly someTag: IsSomeTag;
    readonly tag: IsTag;
  };

  /* model */
  readonly create: Create;
  readonly destroy: Destroy;

  /* query */
  query: {
    readonly focusable: TQueryFocusable;
    readonly main: TQueryMain;
  };

  /* strategy */
  strategy: {
    readonly region: TRegionStrategy;
  };
}

/**
 *
 * @public
 * @hidden
 */
const dom: DOM = {
  /* attr */
  excludeAttrList,
  includeAttrList,
  setAttrs,
  setAttr,

  /* constants */
  constants: {
    noEl
  },

  /* database */
  write,
  read,

  /* element */
  existsIn,
  parentsOf,
  queryAll,
  queryOne,
  removeAll,

  /* is */
  is: {
    customElement,
    element,
    node,
    someTag,
    tag
  },

  /* model */
  create,
  destroy,

  /* query */
  query: {
    focusable,
    main
  },

  /* strategy */
  strategy: {
    region
  }
};

export default dom;
